/* eslint-disable no-unused-expressions */

import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import sysJwt from "../../../utils/sysJwt";
import SysForm from "../../commonComponents/sysForm";
import { post } from "../../../utils/sysAxios";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import SysTable from "../../commonComponents/SysTable";

class CompoundServiceMap extends Component {
  state = {
    data: {
      compoundId: "",
      serviceId: "",
      providerUrl: "",
      providerUsername: "",
      providerPassword: "",
      secondProviderUrl: "",
      secondProviderUsername: "",
      secondProviderPassword: "",
    },

    dataUrl: "/api/data/GetCompoundServiceMaps",
    addUrl: "/api/data/AddCompoundServiceMap",
    editUrl: "/api/data/EditCompoundServiceMap",

    inEditMode: false,
    inModalMode: false,
    modalWidth: "50vw",

    editEntityId: 0,

    compoundsDropdown: [],
    servicesDropdown: [],

    tableData: [],
  };

  componentDidMount() {
    this.getData();
    this.getCompoundsDropdown();
    this.getServicesDropdown();
  }

  getCompoundsDropdown() {
    post("/api/data/GetAllCompoundsDropdown", null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({ compoundsDropdown: apiResponse.data.respData.data });
      }
    );
  }

  getServicesDropdown() {
    post("/api/data/GetAllServices", null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({ servicesDropdown: apiResponse.data.respData.data });
      }
    );
  }

  updateForm = (inputId, inputValue) => {
    var data = this.state.data;
    data[inputId] = inputValue;
    this.setState({ data });
  };

  showForm() {
    this.setState({ inModalMode: true });
  }

  closeModal() {
    var data = this.state.data;
    Object.keys(data).forEach(function (key) {
      Array.isArray(data[key]) ? (data[key] = []) : (data[key] = "");
    });
    this.setState({ inModalMode: false, inEditMode: false, data, editEntityId: 0 });
    this.getData();
  }

  getData() {
    post(this.state.dataUrl, null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({ tableData: apiResponse.data.respData.data });
      }
    );
  }

  // The list never carries passwords, so the edit form fills from the row and leaves both
  // password fields blank. Blank on save means "keep the stored password".
  getEditFormData(row) {
    var data = this.state.data;
    data["compoundId"] = row.COMPOUND_ID;
    data["serviceId"] = row.SERVICE_ID;
    data["providerUrl"] = row.PROVIDER_URL ?? "";
    data["providerUsername"] = row.PROVIDER_USERNAME ?? "";
    data["providerPassword"] = "";
    data["secondProviderUrl"] = row.SECOND_PROVIDER_URL ?? "";
    data["secondProviderUsername"] = row.SECOND_PROVIDER_USERNAME ?? "";
    data["secondProviderPassword"] = "";
    this.setState({ data, editEntityId: row.ID });
  }

  doSubmit() {
    const submitData = Object.assign({}, this.state.data);

    if (this.state.inEditMode) {
      submitData["id"] = this.state.editEntityId;
    }

    post(
      this.state.inEditMode ? this.state.editUrl : this.state.addUrl,
      submitData,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      if (apiResponse.data.respCode === 0) {
        this.props.updateIsLoading(false);
        this.closeModal();
      }
    });
  }

  getColumns() {
    const { t } = this.props;
    const passwordSet = (isSet) => (
      <span style={{ color: isSet ? "#155724" : "#999" }}>
        {isSet ? t("csm.passwordSet") : t("csm.passwordNotSet")}
      </span>
    );

    return [
      { id: 1, label: t("col.id"), field: "ID", width: "80px" },
      { id: 2, label: t("col.compound"), field: "COMPOUND_NAME" },
      { id: 3, label: t("col.serviceName"), field: "SERVICE_NAME" },
      { id: 4, label: t("csm.providerUrl"), field: "PROVIDER_URL" },
      { id: 5, label: t("csm.providerUsername"), field: "PROVIDER_USERNAME" },
      {
        id: 6,
        label: t("csm.providerPassword"),
        field: "HAS_PROVIDER_PASSWORD",
        cellRenderer: ({ data }) => passwordSet(data.HAS_PROVIDER_PASSWORD),
      },
      { id: 7, label: t("csm.secondProviderUrl"), field: "SECOND_PROVIDER_URL" },
      { id: 8, label: t("csm.secondProviderUsername"), field: "SECOND_PROVIDER_USERNAME" },
      {
        id: 9,
        label: t("csm.secondProviderPassword"),
        field: "HAS_SECOND_PROVIDER_PASSWORD",
        cellRenderer: ({ data }) => passwordSet(data.HAS_SECOND_PROVIDER_PASSWORD),
      },
      { id: 10, label: t("col.insertDate"), field: "INSERT_DATE" },
      {
        id: 11,
        label: t("col.actions"),
        field: "SYS_ACTIONS",
        width: "80px",
        resizable: false,
        pinned: true,
        cellRenderer: ({ data }) => (
          <div id="outer">
            {sysJwt.isAuthorized(["CB9A"]) && (
              <div className="inner" title="Edit">
                <button
                  className="dropdown-item btn-popup-menu"
                  disabled={this.props.isLoading}
                  onClick={() => {
                    this.getEditFormData(data);
                    this.setState({ inEditMode: true });
                    this.showForm();
                  }}
                >
                  <i className="fa fa-edit" />
                </button>
              </div>
            )}
          </div>
        ),
      },
    ];
  }

  render() {
    const { t } = this.props;
    const passwordTooltip = this.state.inEditMode ? t("csm.passwordKeepHint") : undefined;

    return (
      <div className="bms-content-component fade-in">
        <div className="row">
          <div className="col">
            <h4>{t("pages.compoundServiceMap")}</h4>
          </div>
          <div className="col flex-container-left">
            {sysJwt.isAuthorized(["CB99"]) && (
              <Button
                label={t("pages.addCompoundServiceMap")}
                icon="fa fa-plus"
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => {
                  this.setState({ inEditMode: false });
                  this.showForm();
                }}
              />
            )}
          </div>
        </div>
        <hr />
        <Dialog
          visible={this.state.inModalMode}
          style={{ width: this.state.modalWidth }}
          onHide={() => this.closeModal()}
          dismissableMask={true}
          closable={false}
          header={
            <h5 className="modal-header">
              {this.state.inEditMode ? t("dialog.editTitle") : t("dialog.addTitle")}
            </h5>
          }
          footer={
            <div>
              <Button
                label={this.state.inEditMode ? t("btn.edit") : t("btn.add")}
                icon={this.state.inEditMode ? "fa fa-edit" : "fa fa-plus"}
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => this.doSubmit()}
              />
              <Button
                label={t("btn.cancel")}
                icon="fa fa-close"
                className="p-button-rounded p-button-danger"
                onClick={() => this.closeModal()}
              />
            </div>
          }
        >
          {this.state.inEditMode && (
            <div style={{ marginBottom: "10px", padding: "6px 10px", background: "#e2e3e5", color: "#383d41", borderRadius: "4px", fontSize: "12px" }}>
              {t("csm.passwordKeepHint")}
            </div>
          )}
          <SysForm
            isLoading={this.props.isLoading}
            inEditMode={this.state.inEditMode}
            data={this.state.data}
            updateForm={this.updateForm}
            inputs={[
              {
                type: "dropdown",
                id: "compoundId",
                label: t("col.compound"),
                options: this.state.compoundsDropdown,
                disabled: false,
              },
              {
                type: "dropdown",
                id: "serviceId",
                label: t("col.serviceName"),
                options: this.state.servicesDropdown,
                disabled: false,
              },
              {
                type: "text",
                id: "providerUrl",
                label: t("csm.providerUrl"),
                disabled: false,
              },
              {
                type: "text",
                id: "providerUsername",
                label: t("csm.providerUsername"),
                disabled: false,
              },
              {
                type: "password",
                id: "providerPassword",
                label: t("csm.providerPassword"),
                tooltip: passwordTooltip,
                disabled: false,
              },
              {
                type: "text",
                id: "secondProviderUrl",
                label: t("csm.secondProviderUrl"),
                disabled: false,
              },
              {
                type: "text",
                id: "secondProviderUsername",
                label: t("csm.secondProviderUsername"),
                disabled: false,
              },
              {
                type: "password",
                id: "secondProviderPassword",
                label: t("csm.secondProviderPassword"),
                tooltip: passwordTooltip,
                disabled: false,
              },
            ]}
          />
        </Dialog>
        <SysTable
          columns={this.getColumns()}
          rows={this.state.tableData}
          pageSizes={[10, 15, 20, 25, 30]}
        />
      </div>
    );
  }
}

export default withTranslation()(CompoundServiceMap);
